
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSensorWaterOrpGoogle as ObiSensorWaterOrpGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sensor-water-orp-google.js';
 
 
 

 
 export const ObiSensorWaterOrpGoogle = createComponent({
   react: React,
   tagName: 'obi-sensor-water-orp-google',
   elementClass: ObiSensorWaterOrpGoogleElement,
   events: {
     
   }
  });
 
 